import { BASE_ADMIN_V2_PATH } from '../../shared/admin/constants/path.constants';

const ADMIN_ORDER_V2_APP_ROOT = `${BASE_ADMIN_V2_PATH}/orders`;

export const ADMIN_ORDER_APP_PATHS = {
  ORDER_DETAILS: (orderId: string) => `${ADMIN_ORDER_V2_APP_ROOT}/${orderId}/details`,
  ORDER_UPDATE: (orderId: string) => `${ADMIN_ORDER_V2_APP_ROOT}/${orderId}/update`,
};

export const ADMIN_ORDER_V2_APP_PATHS = {
  ORDERS_OVERVIEW: `${ADMIN_ORDER_V2_APP_ROOT}`,
  ORDER_DETAILS: (orderId: string) => `${ADMIN_ORDER_V2_APP_ROOT}/${orderId}/details`,
  ARCHIVE_ORDER: `${ADMIN_ORDER_V2_APP_ROOT}/to-archive`,
  DELIVERY_NOTES_LIST: `${ADMIN_ORDER_V2_APP_ROOT}/delivery-notes`,
};
